// The roles a user works in, which set the terms, menus and figures of the app
// to how they look at a case: a law firm's or an insurer's. Shared by client
// and server.
//
// An admin gives a user their roles in `personas`, a string array on their
// `_User` that only the master key can write; the user picks the one they work
// in, `activePersona`, among them. A user without roles is a law firm. Not
// called roles: Parse has its own, which decide access.
export const PERSONAS = ["lawFirm", "insurer"] as const;

export type Persona = (typeof PERSONAS)[number];

export const isPersona = (value: unknown): value is Persona =>
  PERSONAS.includes(value as Persona);

// The roles of a user, from the `personas` stored on them. Anything but a
// list, and any name in it that is not a role, is ignored; without a role
// left, the user is a law firm.
export function resolvePersonas(stored: unknown): Persona[] {
  const personas = PERSONAS.filter(
    (persona) => Array.isArray(stored) && stored.includes(persona),
  );
  return personas.length > 0 ? personas : ["lawFirm"];
}

// The role a user works in: the one they picked, if it is among their roles,
// else their first.
export function resolveActivePersona(
  personas: Persona[],
  active: unknown,
): Persona {
  return isPersona(active) && personas.includes(active) ? active : personas[0];
}
